import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { TournamentPayoutType } from '@okletsplay/core';
import {
  usePrizeAndDistributionStatistic,
  useTournamentTeamDetails,
} from 'modules/tournaments/hooks';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';

export const TournamentPrizesTitle: FC = () => {
  const tournament = useSelector(currentTournamentSelector.tournament);
  const { activeTeamsCount } = useTournamentTeamDetails(tournament);

  const { minTeams } = tournament?.teamsSettings ?? {};

  const { payoutType } = tournament?.prizeAndDistribution ?? {};

  const {
    playerPrizePool: { min: minPrizePool, max: maxPrizePool, current: currentPrizePool },
  } = usePrizeAndDistributionStatistic(tournament);

  const getLabelComponent = useCallback(
    (text: string) => (
      <Typography variant="subtitle1" mb={2}>
        {text}
      </Typography>
    ),
    []
  );

  if (!currentPrizePool) return null;
  if (minPrizePool === maxPrizePool) return null;

  if (payoutType === TournamentPayoutType.TopPercent) {
    return getLabelComponent('Per team. Assumes max teams joined.');
  }

  if (activeTeamsCount < minTeams) {
    return getLabelComponent('Per team. Assumes min teams joined.');
  }

  return null;
};
